// src/pages/NotificationTemplates/NotificationTemplatesPage.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import NotificationTemplates from '../../components/NotificationTemplates/NotificationTemplates';

const NotificationTemplatesPage = () => {
    return (
        <>
            <Helmet>
                <title>Templates de Notificaciones - PetitPrime</title>
                <meta name="description" content="Gestiona los templates personalizados para tus notificaciones" />
            </Helmet>

            <div className="container mx-auto px-4 py-8">
                <NotificationTemplates />
            </div>
        </>
    );
};

export default NotificationTemplatesPage; 